import { FlaskConical } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-200" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid sm:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="h-8 w-8 rounded-sm bg-sky-700 flex items-center justify-center">
              <FlaskConical className="h-4 w-4 text-white" />
            </span>
            <span className="font-display font-bold text-slate-900">Arias Peptides</span>
          </div>
          <p className="text-xs text-slate-500 mt-4 leading-relaxed max-w-xs">
            Distributor of batch-verified lyophilized research peptides and analytical reference
            standards. Strictly for laboratory and in-vitro research use.
          </p>
        </div>
        <div>
          <p className="font-tech text-[11px] uppercase tracking-[0.18em] text-slate-400 mb-3">Navigate</p>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/catalog" data-testid="footer-catalog-link" className="text-slate-600 hover:text-sky-700">Research Catalog</Link>
            <a href="/#wholesale" className="text-slate-600 hover:text-sky-700">Wholesale Program</a>
            <a href="/#quality" className="text-slate-600 hover:text-sky-700">Quality &amp; COA</a>
            <Link to="/coa-library" data-testid="footer-coa-library-link" className="text-slate-600 hover:text-sky-700">COA Library</Link>
            <Link to="/suppliers" data-testid="footer-suppliers-link" className="text-slate-600 hover:text-sky-700">Suppliers</Link>
            <Link to="/track" className="text-slate-600 hover:text-sky-700">Track Order</Link>
          </div>
        </div>
        <div>
          <p className="font-tech text-[11px] uppercase tracking-[0.18em] text-slate-400 mb-3">Compliance Notice</p>
          <p className="text-xs text-slate-500 leading-relaxed">
            All products are Research Use Only (RUO). Not for human consumption, diagnostic, or
            therapeutic use. Purchasers must be qualified researchers and accept the RUO attestation
            prior to order review.
          </p>
        </div>
      </div>
      <div className="border-t border-slate-100 py-4 text-center">
        <p className="font-tech text-[11px] text-slate-400">© 2026 Arias Peptides · Laboratory Supply Division</p>
      </div>
    </footer>
  );
}
